import { toast, ToastOptions, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultOptions: ToastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
};

class ToastService {
    showSuccess(message: string, options: ToastOptions = {}) {
        toast.success(message, { ...defaultOptions, ...options });
    }

    showError(message: string, options: ToastOptions = {}) {
        toast.error(message, { ...defaultOptions, ...options });
    }

    showInfo(message: string, options: ToastOptions = {}) {
        toast.info(message, { ...defaultOptions, ...options });
    }

    showWarning(message: string, options: ToastOptions = {}) {
        toast.warn(message, { ...defaultOptions, ...options });
    }

    promise<T>(
        promise: Promise<T>,
        messages: {
            pending: string;
            success: string;
            error: string;
        },
        options: ToastOptions = {}
    ) {
        toast.promise(promise, messages, { ...defaultOptions, ...options });
    }
}

const toastService = new ToastService();
export default toastService; 